import { Tab, TabGroup, TabList } from '@headlessui/react'
import React from 'react'

export interface TabOption {
  label: string
  value: string
  disabled?: boolean
}

interface TabsProps {
  options: TabOption[]
  activeValue: string
  onChange: (key: string) => void
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const Tabs: React.FC<TabsProps> = ({
  options,
  activeValue,
  onChange,
  className = '',
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'py-1 px-1 text-xs',
    md: 'py-2 px-1 text-sm',
    lg: 'py-3 px-1 text-base'
  }

  const spacingClasses = {
    sm: 'space-x-4',
    md: 'space-x-8',
    lg: 'space-x-12'
  }

  // Find the selected index based on activeKey
  const selectedIndex = options.findIndex(
    (option) => option.value === activeValue
  )

  return (
    <div className={`border-b border-gray-200 mb-6 ${className}`}>
      <TabGroup
        selectedIndex={selectedIndex >= 0 ? selectedIndex : 0}
        onChange={(index) => onChange(options[index].value)}
      >
        <TabList className={`-mb-px flex ${spacingClasses[size]}`}>
          {options.map((item) => (
            <Tab
              key={item.value}
              disabled={item.disabled}
              className={`${
                sizeClasses[size]
              } border-b-2 font-medium transition-colors duration-200 focus:outline-none data-[selected]:border-blue-500 data-[selected]:text-blue-600 data-[hover]:text-gray-700 data-[hover]:border-gray-300 border-transparent text-gray-500 ${
                item.disabled
                  ? 'opacity-50 cursor-not-allowed'
                  : 'cursor-pointer'
              }`}
            >
              {item.label}
            </Tab>
          ))}
        </TabList>
      </TabGroup>
    </div>
  )
}

export default Tabs
